module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-accessories-icon-2-c51b8c0d9d158a16a2c151ba01d2e841.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-accessories-icon-2.svg
 ** module id = 1002
 ** module chunks = 1 75
 **/